import styled from 'styled-components'

export const ContestModalWrapper = styled.div`
  margin: 6rem 20px 0 20px;

  h3 {
    font-weight: 600;
    font-size: ${({ theme }) => theme.fontSize.xxl};
    color: ${({ theme }) => theme.colors.black};
  }

  p {
    font-weight: 400;
    font-size: ${({ theme }) => theme.fontSize.x6};
    color: ${({ theme }) => theme.colors.black};
    margin: 0;
  }
`

export const AboutDetails = styled.div``

export const TextContainer = styled.div``

export const ImageWrapper = styled.div`
  background-color: #ddcdff;
  height: 44px;
  width: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
`

export const DetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 0;
`
